"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var CustomerRepository_1 = __importDefault(require("../repositories/CustomerRepository"));
var ApiConfiguration_1 = __importDefault(require("../utils/models/ApiConfiguration"));
var CustomerService = /** @class */ (function () {
    function CustomerService() {
    }
    CustomerService.getOneById = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var customer, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, CustomerRepository_1.default.getOneById(id)];
                    case 1:
                        customer = _a.sent();
                        return [2 /*return*/, Promise.resolve(customer)];
                    case 2:
                        e_1 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_1)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CustomerService.getOneByUUID = function (customerUUID) {
        return __awaiter(this, void 0, void 0, function () {
            var customer, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, CustomerRepository_1.default.getOneByUUID(customerUUID)];
                    case 1:
                        customer = _a.sent();
                        return [2 /*return*/, Promise.resolve(customer)];
                    case 2:
                        e_2 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_2)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CustomerService.resetPassword = function (email) {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        response = void 0;
                        if (!ApiConfiguration_1.default.getHeader('brandId')) return [3 /*break*/, 2];
                        return [4 /*yield*/, CustomerRepository_1.default.resetPasswordV2(email)];
                    case 1:
                        response = _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, CustomerRepository_1.default.resetPassword(email)];
                    case 3:
                        response = _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/, Promise.resolve(response)];
                    case 5:
                        e_3 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_3)];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    CustomerService.create = function (entity, google) {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        if (google) {
                            entity.google = true;
                        }
                        response = void 0;
                        if (!ApiConfiguration_1.default.getHeader('brandId')) return [3 /*break*/, 2];
                        return [4 /*yield*/, CustomerRepository_1.default.createV2(entity)];
                    case 1:
                        response = _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, CustomerRepository_1.default.create(entity)];
                    case 3:
                        response = _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/, Promise.resolve(response)];
                    case 5:
                        e_4 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_4)];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    CustomerService.update = function (customerId, entity) {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, CustomerRepository_1.default.update(customerId, entity)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, Promise.resolve(response)];
                    case 2:
                        e_5 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_5)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CustomerService.updateV2 = function (customerUUID, entity) {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, CustomerRepository_1.default.updateV2(customerUUID, entity)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, Promise.resolve(response)];
                    case 2:
                        e_6 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_6)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CustomerService.updatePushNotificationsState = function (customerId, allowed) {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, CustomerRepository_1.default.updatePushNotificationsState(customerId, allowed)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, Promise.resolve(response)];
                    case 2:
                        e_7 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_7)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CustomerService.updatePushNotificationsStateV2 = function (customerUUID, allowed) {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, CustomerRepository_1.default.updatePushNotificationsStateV2(customerUUID, allowed)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, Promise.resolve(response)];
                    case 2:
                        e_8 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_8)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CustomerService.checkLocation = function (customerUUID) {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, CustomerRepository_1.default.checkLocation(customerUUID)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, Promise.resolve(response)];
                    case 2:
                        e_9 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_9)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CustomerService.linkFirm = function (customerId) {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_10;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, CustomerRepository_1.default.linkFirm(customerId)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, Promise.resolve(response)];
                    case 2:
                        e_10 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_10)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CustomerService.checkEmailV2 = function (email, google) {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_11;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, CustomerRepository_1.default.checkEmailV2(email, google)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, Promise.resolve(response)];
                    case 2:
                        e_11 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_11)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CustomerService.checkEmail = function (email, google) {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_12;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, CustomerRepository_1.default.checkEmail(email, google)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, Promise.resolve(response)];
                    case 2:
                        e_12 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_12)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CustomerService.checkActivation = function (customerId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                try {
                    return [2 /*return*/, CustomerRepository_1.default.checkActivation(customerId)];
                }
                catch (e) {
                    return [2 /*return*/, Promise.reject(e)];
                }
                return [2 /*return*/];
            });
        });
    };
    CustomerService.initSocialLogin = function (socialMedia) {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_13;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, CustomerRepository_1.default.initSocialLogin(socialMedia)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, Promise.resolve(response)];
                    case 2:
                        e_13 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_13)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CustomerService.checkSocialToken = function (socialToken) {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_14;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, CustomerRepository_1.default.checkSocialToken(socialToken)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, Promise.resolve(response)];
                    case 2:
                        e_14 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_14)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CustomerService.saveDeviceToken = function (customerId, deviceToken) {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_15;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, CustomerRepository_1.default.saveDeviceToken(customerId, deviceToken)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, Promise.resolve(response)];
                    case 2:
                        e_15 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_15)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CustomerService.checkAccessToken = function (code, tokenId) {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_16;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, CustomerRepository_1.default.checkAccessToken(code, tokenId)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, Promise.resolve(response)];
                    case 2:
                        e_16 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_16)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CustomerService.getMessages = function (customerId) {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_17;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, CustomerRepository_1.default.getMessages(customerId)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, Promise.resolve(response)];
                    case 2:
                        e_17 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_17)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CustomerService.markMessageAsRead = function (customerId, messageId) {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_18;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, CustomerRepository_1.default.markMessageAsRead(customerId, messageId)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, Promise.resolve(response)];
                    case 2:
                        e_18 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_18)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CustomerService.getCustomerAddresses = function (uuid) {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_19;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, CustomerRepository_1.default.getCustomerAddresses(uuid)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, Promise.resolve(response)];
                    case 2:
                        e_19 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_19)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CustomerService.updateCustomerAddress = function (uuid, address) {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_20;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, CustomerRepository_1.default.updateCustomerAddress(uuid, address)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, Promise.resolve(response)];
                    case 2:
                        e_20 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_20)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CustomerService.addCustomerAddress = function (uuid, address) {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_21;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, CustomerRepository_1.default.addCustomerAddress(uuid, address)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, Promise.resolve(response)];
                    case 2:
                        e_21 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_21)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CustomerService.updateBusinessDetails = function (uuid, businessDetails) {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_22;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, CustomerRepository_1.default.updateBusinessDetails(uuid, businessDetails)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, Promise.resolve(response)];
                    case 2:
                        e_22 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_22)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CustomerService.deleteCustomer = function (uuid) {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_23;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        response = void 0;
                        if (!ApiConfiguration_1.default.getHeader('brandId')) return [3 /*break*/, 2];
                        return [4 /*yield*/, CustomerRepository_1.default.deleteCustomerV2(uuid)];
                    case 1:
                        response = _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, CustomerRepository_1.default.deleteCustomer(uuid)];
                    case 3:
                        response = _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/, Promise.resolve(response)];
                    case 5:
                        e_23 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_23)];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    return CustomerService;
}());
exports.default = CustomerService;
